import { cn } from "@/engine/support/classNames";

/**
 * Home's movements, each switched on only once the visitor has switched panels
 * (#845; see `useSwitchedOnce`). Before that the page is drawn still.
 */
export const entryMotion = (switched: boolean) => ({
  cardSpace: cn(
    "min-h-[268px] sm:min-h-[312px] lg:min-h-[332px] lg:flex-1",
    switched &&
      "transition-[min-height] duration-(--motion-slow) ease-(--motion-enter)",
  ),
  card: cn(
    "glass-strong border-border/30 overflow-hidden lg:min-h-full",
    switched &&
      "transition-[height] duration-(--motion-slow) ease-(--motion-enter)",
  ),
  panel: cn(
    "p-3 sm:p-5 lg:p-6",
    switched && "motion-arrive [--motion-duration:var(--motion-slow)]",
  ),
  column: cn(
    "relative z-10 w-full",
    switched &&
      "transition-[max-width] duration-(--motion-slow) ease-(--motion-enter)",
  ),
});
